import React from "react";

import OnBoardingLayout from "../components/on-boarding-layout";
import UploadContract from "../components/uploadContract";

export default function UploadContractScreen() {
  return <OnBoardingLayout screen={<UploadContract />} withoutContainer={true} />;
}
